import { ThemedIcon } from '@/design-system/icons';
import type { IconName } from '@/design-system/icons/types';
import { cn } from '@/lib';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Button } from './Button';

export interface ButtonIconTextProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  iconName: IconName;
  iconClassName?: string;
}

/**
 * @component ButtonIconText
 * @description Renders a neutral action button with a themed icon before its label content.
 *
 * @props
 *   children (ReactNode, required) - Label content rendered after the icon.
 *   iconName (IconName, required) - The themed icon key to render.
 *   iconClassName (string, optional) - Additional classes for the icon element.
 */
export function ButtonIconText({ children, iconName, iconClassName, ...props }: ButtonIconTextProps) {
  return (
    <Button {...props}>
      <ThemedIcon name={iconName} className={cn('size-4', iconClassName)} />
      {children}
    </Button>
  );
}
